import { Button } from "./ui/Button";
import { ArrowRight } from "lucide-react";
import { useState } from "react";
import { openWhatsApp } from "../utils/whatsapp";

export default function Enquiries() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [messageText, setMessageText] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const msg = `Hello! I would like to make an enquiry with BeginPack Ltd.\n\nName: ${name}\nEmail: ${email}\nPhone: ${phone}\nService Type: ${serviceType}\nMessage: ${messageText}`;
    openWhatsApp(msg);
  };

  return (
    <div
      className="bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen flex flex-col items-center justify-center px-4 py-12 md:py-16"
      content-visibility="auto"
      contain-intrinsic-size="800px"
    >
      <div className="max-w-4xl mx-auto mb-10 md:mb-12">
        <h1 className="font-['Poppins'] text-center text-gray-900 font-bold mb-4 text-3xl sm:text-4xl lg:text-5xl tracking-tight antialiased leading-tight">
          We're Here to Help
        </h1>
        <p className="font-['Plus_Jakarta_Sans'] text-center text-gray-600 text-base md:text-lg tracking-tight antialiased leading-relaxed max-w-3xl mx-auto">
          Whether you're unsure where to start or need help with your next step,
          our team's here to provide help to make your travel process easier.
        </p>
      </div>

      <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 lg:p-10 w-full max-w-4xl border border-gray-100">
        <div className="mb-8">
          <h2 className="font-['Poppins'] text-2xl md:text-3xl font-bold mb-3 text-gray-900 tracking-tight antialiased">
            Get in Touch with Us!
          </h2>
          <p className="font-['Plus_Jakarta_Sans'] text-gray-600 tracking-tight antialiased leading-relaxed">
            From bookings to destinations, our help center simplifies everything
            so you can focus on the excitement, not the confusion.
          </p>
        </div>

        <div className="space-y-5">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="flex flex-col">
              <label
                htmlFor="name"
                className="font-['Plus_Jakarta_Sans'] text-sm font-semibold text-gray-700 mb-2 tracking-tight antialiased"
              >
                Name
              </label>
              <input
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                type="text"
                placeholder="Enter your full name"
                className="font-['Plus_Jakarta_Sans'] border border-gray-300 rounded-lg px-4 py-3 outline-none focus:ring-2 focus:ring-[#223F91] focus:border-transparent text-gray-900 placeholder:text-gray-400 transition-all duration-200 tracking-tight antialiased"
                aria-required="true"
              />
            </div>

            <div className="flex flex-col">
              <label
                htmlFor="email"
                className="font-['Plus_Jakarta_Sans'] text-sm font-semibold text-gray-700 mb-2 tracking-tight antialiased"
              >
                Email
              </label>
              <input
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                placeholder="Enter your email"
                className="font-['Plus_Jakarta_Sans'] border border-gray-300 rounded-lg px-4 py-3 outline-none focus:ring-2 focus:ring-[#223F91] focus:border-transparent text-gray-900 placeholder:text-gray-400 transition-all duration-200 tracking-tight antialiased"
                aria-required="true"
              />
            </div>

            <div className="flex flex-col">
              <label
                htmlFor="phone"
                className="font-['Plus_Jakarta_Sans'] text-sm font-semibold text-gray-700 mb-2 tracking-tight antialiased"
              >
                Phone
              </label>
              <input
                id="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                type="tel"
                placeholder="Enter your phone number"
                className="font-['Plus_Jakarta_Sans'] border border-gray-300 rounded-lg px-4 py-3 outline-none focus:ring-2 focus:ring-[#223F91] focus:border-transparent text-gray-900 placeholder:text-gray-400 transition-all duration-200 tracking-tight antialiased"
              />
            </div>

            <div className="flex flex-col">
              <label
                htmlFor="service-type"
                className="font-['Plus_Jakarta_Sans'] text-sm font-semibold text-gray-700 mb-2 tracking-tight antialiased"
              >
                Service Type
              </label>
              <select
                id="service-type"
                value={serviceType}
                onChange={(e) => setServiceType(e.target.value)}
                className="font-['Plus_Jakarta_Sans'] border border-gray-300 rounded-lg px-4 py-3 outline-none focus:ring-2 focus:ring-[#223F91] focus:border-transparent text-gray-900 bg-white transition-all duration-200 tracking-tight antialiased cursor-pointer"
              >
                <option value="">Select a service</option>
                <option value="travel">Flight Ticket Booking</option>
                <option value="admission">Study Abroad Services</option>
                <option value="visa">Migration Services</option>
                <option value="other">General Inquiry</option>
              </select>
            </div>
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="message"
              className="font-['Plus_Jakarta_Sans'] text-sm font-semibold text-gray-700 mb-2 tracking-tight antialiased"
            >
              Message
            </label>
            <textarea
              id="message"
              rows={5}
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              placeholder="Write your message..."
              className="font-['Plus_Jakarta_Sans'] border border-gray-300 rounded-lg px-4 py-3 outline-none focus:ring-2 focus:ring-[#223F91] focus:border-transparent text-gray-900 placeholder:text-gray-400 transition-all duration-200 tracking-tight antialiased resize-none"
            />
          </div>

          <Button
            onClick={handleSubmit}
            variant="primary"
            size="lg"
            className="w-full mt-2"
            rightIcon={<ArrowRight className="w-5 h-5" />}
          >
            Submit Enquiry
          </Button>
        </div>
      </div>
    </div>
  );
}
